import { Box, Dialog } from '@mui/material';
import invalidIcon from 'assets/icons/invalidIcon.svg';
import validIcon from 'assets/icons/validIcon.svg';

import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { TitleMedium } from 'v3/shared/typography/TitleMedium';
import { theme } from 'v3/styles/global-styles';
import {
  AlignButtons,
  changeValuePaperPropsStyle,
  Container,
  CountContainer,
  Header,
  InvalidRowsContainer,
  InvalidRowStyled,
  StyledCloseIcon,
  TitleContainer,
} from './styles';
import { IChangeValueModalProps } from './types';

export const SellerInvalidRowsModal: React.FC<IChangeValueModalProps> = ({ data, active, onClose, onConfirm }) => {
  return (
    <Dialog
      onClose={onClose}
      open={active}
      aria-labelledby="customized-dialog-title"
      PaperProps={changeValuePaperPropsStyle}
    >
      <Container>
        <Header>
          <StyledCloseIcon onClick={onClose} />
          <TitleContainer>
            <HeadlineSmall color={theme.palette.common.white}>Upload concluído com pendências</HeadlineSmall>
            <SubtitleLarge color={theme.palette.secondary.light}>
              Seu arquivo foi processado mas algumas linhas não foram cadastradas
            </SubtitleLarge>
          </TitleContainer>
        </Header>
        <CountContainer>
          <img src={validIcon} alt="valid icon" />
          <SubtitleMedium color={theme.palette.secondary.light}>
            {data.validRowsCount} linhas de {data.totalRows} foram cadastradas com sucesso
          </SubtitleMedium>
        </CountContainer>
        <CountContainer>
          <img src={invalidIcon} alt="Invalid icon" />
          <SubtitleMedium color={theme.palette.secondary.light}>
            {data.invalidRowsCount} linhas de {data.totalRows} não foram cadastradas porque possuem inconsistências
          </SubtitleMedium>
        </CountContainer>
        <InvalidRowsContainer>
          {data.invalidRows.map((row, index) => {
            return (
              <InvalidRowStyled key={index}>
                <BodySmallRegular color={theme.palette.common.white}>
                  Linha {row.line} | {row.data[0]} {row.data[1]}
                </BodySmallRegular>
              </InvalidRowStyled>
            );
          })}
        </InvalidRowsContainer>

        <Box>
          <TitleMedium color={theme.palette.secondary.light}>
            *Corrija esses itens e reenvie apenas as linhas com problemas
          </TitleMedium>

          <AlignButtons>
            <FlexButton
              data-testid="flex-button-save-button"
              size="small"
              text={'Ok, entendi'}
              handleClick={onConfirm}
              fullWidth
            />
          </AlignButtons>
        </Box>
      </Container>
    </Dialog>
  );
};
